const SKYBOX_SIZE = 2000;

export {
  SKYBOX_SIZE,
};
